import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAdminClassDayGetAdminClassDayDetailQueryOptions } from "@/orval/admin-class-day";
import { parseClassDayIdParams } from "@/lib/route-params";

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/class-days_/$classDayId")({
  parseParams: parseClassDayIdParams,
  loader: async ({ context, params }) => {
    const classDay = await context.queryClient.ensureQueryData(
      getAdminClassDayGetAdminClassDayDetailQueryOptions(params.organizationId, params.classDayId),
    );
    throw redirect({
      to: "/organizations/$organizationId/admin/semesters/$semesterId",
      params: { organizationId: params.organizationId, semesterId: classDay.semesterId },
      search: { tab: "class-days" },
      replace: true,
    });
  },
});
